import { render, staticRenderFns } from "./TV3.vue?vue&type=template&id=6f3386d6&scoped=true&"
import script from "./TV3.vue?vue&type=script&lang=js&"
export * from "./TV3.vue?vue&type=script&lang=js&"
import style0 from "./TV3.vue?vue&type=style&index=0&id=6f3386d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3386d6",
  null
  
)

export default component.exports